module.exports = __webpack_public_path__ + "img/FormsLetters-active.2b0e71ca.svg";